import {classNames} from "shared/lib/classNames/classNames";
import { ButtonHTMLAttributes, FC } from "react";
import cls from "./Button.module.scss";

export enum ButtonTheme {
    CLEAR = "clear",
    PRIMARY = "primary",
    SECONDARY = "secondary",
}


interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>{
    className?: string;
    theme?: ButtonTheme;
}

const Button: FC<ButtonProps> = (props) => {
    const {
        className,
        children,
        theme,
        ...rest
    } = props;
    return (
        <button
            className={classNames(cls.Button, {}, [className, theme ? cls[theme] : undefined])}
            {...rest}
        >
            {children}
        </button>
    );
};

export default Button;
